import { CoreMediaService, MediaService } from '@services/common/media.service';
import { ChatComponent } from './content/chat.component';
import { CommonModule } from '@angular/common';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { CommunitiesRoutingModule } from './communities-routing.module';
import { CommunityGuard } from './guards/community.guard';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { FilterRoomsPipe } from '@tso-pipes/filter.pipe';
import { FormsModule } from '@angular/forms';
import { GenericServicesModule } from '@modules/generic-services/generic-services.module';
import { LayoutModule } from './modules/layout/layout.module';
import { LightboxModule } from 'ngx-lightbox';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ReactiveFormsModule } from '@angular/forms';
import { SimplebarAngularModule } from '@modules/simplebar-angular/simplebar-angular.module';
import { UiModule } from '@modules/ui/ui.module';

@NgModule({
  declarations: [DashboardPageComponent, ChatComponent, FilterRoomsPipe],
  imports: [
    CommonModule,
    CommunitiesRoutingModule,
    NgSelectModule,
    NgbDropdownModule,
    NgbNavModule,
    NgApexchartsModule,
    NgbDatepickerModule,
    NgbModule,
    SimplebarAngularModule,
    LayoutModule,
    UiModule,
    ReactiveFormsModule,
    GenericServicesModule,
    FormsModule,
    PickerModule,
    LightboxModule,
  ],
  providers: [
    CommonVerbsApiService,
    CommunityGuard,
    {
      provide: CoreMediaService,
      useClass: MediaService,
    },
  ],
})
export class CommunitiesModule {}
